import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CmpsIconModule, CmpsIconRegistry } from '@cmps/ng-uikit';
import { mdiClose } from '@mdi/js';

import { CmpsScorecardRankBonusComponent } from './scorecard-rank-bonus.component';

@NgModule({
    declarations: [CmpsScorecardRankBonusComponent],
    imports: [CmpsIconModule, CommonModule],
    exports: [CmpsScorecardRankBonusComponent],
})
export class CmpsScorecardRankBonusModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [['close', mdiClose]].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
